import React from 'react';

const FilterCard = ({ children, className = '' }) => (
  <div className={`bg-white dark:bg-dark-800 rounded-2xl shadow-card border border-gray-100 dark:border-dark-700 p-4 md:p-6 ${className}`}>
    {children}
  </div>
);

export const SearchInput = ({ value, onChange, placeholder, className = '' }) => (
  <div className={`relative flex-1 ${className}`}>
    <svg className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
    <input
      type="text"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="input-modern pl-11 py-2.5 text-sm"
    />
  </div>
);

export const SelectInput = ({ value, onChange, children, label, className = '' }) => (
  <div className={`space-y-2 ${className}`}>
    {label && <label className="text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>}
    <select
      value={value}
      onChange={onChange}
      className="input-modern py-2.5 text-sm cursor-pointer"
    >
      {children}
    </select>
  </div>
);

export default FilterCard;
